import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import Dropdown from 'react-bootstrap/lib/Dropdown';

import FormControl from 'react-bootstrap/lib/FormControl';
import MenuItem from 'react-bootstrap/lib/MenuItem';

class CitySearchField extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      searchOpened: false,
      citiesOptions: [],
      city: '',
      cityString: '',
      cityTitle: '',
      error: ''
    };

    this.searchHandler = this.onSearch.bind(this);
    this.toggleHandler = this.onToggle.bind(this);
    this.blurHandler = this.onBlur.bind(this);
  }

  componentDidMount() {
    if (this.props.initialState) {
      this.setState(this.props.initialState);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.initialState && nextProps.initialState !== this.props.initialState) {
      this.setState(nextProps.initialState);
    }
  }

  onBlur() {
    this.onSelect(this.state.city);
  }

  onToggle(isOpen) {
    this.setState({ searchOpened: isOpen });
  }

  onSearch(e) {
    let q = this.state.cityString;
    if (e) {
      q = e.target.value;
      this.setState({ cityString: q });
    }

    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(() => {
      this.debounceTimeout = null;

      this.props.searchCity(q)
        .then(action => {
          if (action.statusCode === 200 && action.response) {
            if (e) {
              const error = !!action.response.length ? '' : 'error';
              this.setState({ error });
            }

            this.setState({
              citiesOptions: action.response.map(item => {
                return { value: item.id, title: item.nameEn };
              })
            });
          } else {
            this.setState({ citiesOptions: [] });
          }
        });
    }, 400);
  }

  onSelect(value) {
    const selectedCity = this.state.citiesOptions.find(el => el.value === value);

    if (selectedCity) {
      this.setState({
        city: selectedCity.value,
        cityString: this.props.t(selectedCity.title),
        cityTitle: this.props.t(selectedCity.title)
      });

      this.props.onChange(value, selectedCity.title);
    } else {
      this.setState({ cityString: this.state.cityTitle });
    }
  }

  render() {
    const { t, id } = this.props;
    const { searchOpened, citiesOptions } = this.state;
    const open = searchOpened && !!citiesOptions.length;

    return (
      <Dropdown id={id} onToggle={this.toggleHandler} open={open}>
        <Dropdown.Toggle componentClass="div" noCaret>
          <FormControl
            autoComplete="off"
            style={{ border: 'none', margin: 0, padding: 0, width: '100%', height: '100%' }}
            name={'city'}
            value={this.state.cityString}
            onChange={this.searchHandler}
            onBlur={this.blurHandler}
          />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {citiesOptions.map(el =>
            <MenuItem
              key={el.value}
              eventKey={el.value}
              active={this.state.city === el.value}
              onClick={this.onSelect.bind(this, el.value)}
            >
              {t(el.title)}
            </MenuItem>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default translate(['cities'])(CitySearchField);



// WEBPACK FOOTER //
// ./src/widgets/CitySearchField/index.js